import React from "react";
import { useLocation } from "react-router-dom";
import LessSwitcher from "./LessSwitcher";

export default function Lesson() {
  const { pathname } = useLocation();
  return (
    <>
      <LessSwitcher path={pathname} />
    </>
  );
}
